import { render, staticRenderFns } from "./PatientVerificationFeatureDetail.vue?vue&type=template&id=b7bded64&scoped=true"
import script from "./PatientVerificationFeatureDetail.vue?vue&type=script&lang=js"
export * from "./PatientVerificationFeatureDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientVerificationFeatureDetail.vue?vue&type=style&index=0&id=b7bded64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bded64",
  null
  
)

export default component.exports